import React from "react";

import { Tag } from "@/components/ui/tag";
import { cn } from "@/lib/utils";
import type { CasePrepUscisSourceType } from "../../types";
import { sourceTypeLabel } from "../../utils";
import { SOURCE_KINDS, sourceTypeKind } from "./sourceKinds";

/** A fill step's source type as a neutral tag, the icon in its kind's hue. */
export function SourceTypeTag({
  type,
  className
}: {
  type: CasePrepUscisSourceType;
  className?: string;
}) {
  const spec = SOURCE_KINDS[sourceTypeKind(type)];
  const Icon = spec.icon;
  return (
    <Tag className={className} data-testid="source-type-tag">
      <Icon className={cn(spec.hue)} aria-hidden />
      {sourceTypeLabel(type)}
    </Tag>
  );
}
